$(document).ready(function() {

    //console.log('test');

  $('.i-checks').iCheck({
    checkboxClass: 'icheckbox_square-green',
    radioClass: 'iradio_square-green'
  });

  /* initialize the external events
   -----------------------------------------------------------------*/


  $('#external-events div.external-event').each(function() {

// store data so the calendar knows to render an event upon drop
    $(this).data('event', {
      title: $.trim($(this).text()), // use the element's text as the event title
      stick: true // maintain when user navigates (see docs on the renderEvent method)
    });

// make the event draggable using jQuery UI
    $(this).draggable({
      zIndex: 1111999,
      revert: true,      // will cause the event to go back to its
      revertDuration: 0  //  original position after the drag
    });

  });

  //get events from json

  /* initialize the calendar
   -----------------------------------------------------------------*/
  var date = new Date();
  var d = date.getDate();
  var m = date.getMonth();
  var y = date.getFullYear();

  $('#event-calendar').fullCalendar({
    lang: 'nl',
    header: {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay'
    },
    editable: false,
    droppable: false,
    timeFormat: 'H:mm',
    events: '/calendar/timetable',
  eventRender: function(event, element) {
    element.addClass('zaal'+event.zaal);

    if(event.status === 'DECLINED'){ element.addClass('fc-event-declined');}
    if(event.status === 'WAITING'){ element.addClass('fc-event-waiting');}
    if(event.isSubroom === true){ element.addClass('fc-event-sub');}

    //console.log(event);
    //console.log(element);
  },
    eventClick: function(calEvent, jsEvent, view) {

      //generate the url
      $url = '/calendar/eventdetails/'+calEvent.id;

      $.ajax({
        url: $url,
        type: 'GET',
        success: function(result) {
          console.log(result);

          $('.eventModal').find('#title').text(calEvent.title);
          $('.eventModal').find('#details').html(result);

           //display event in modal

          $('.eventModal').on('shown.bs.modal', function (e) {
            $().eventApprove();
            $().eventDecline();
          });

          $('.eventModal').modal();

        },
        error: function(result){
        }
      });





    }
  });



});